import type { UiIconName } from "@dpa-id-components/dpa-shared-components/src/components/UiIcon/UiIcon.vue";
import { defineStore } from "pinia";
import { ref } from "vue";

import type { DisruptionInfo } from "@/composition/shared/sockets/useDisruptionInfoSocket";
import type { MorningBriefing } from "@/types/morningBriefing";

export const useLayoutStore = defineStore("layout", () => {
  const isLoggedIn = ref(false);

  const feedDetailIsOpen = ref(false);
  function openFeedDetail() {
    feedDetailIsOpen.value = true;
  }
  function closeFeedDetail() {
    feedDetailIsOpen.value = false;
  }

  const overlayIsOpen = ref(false);
  function toggleOverlayIsOpen() {
    overlayIsOpen.value = !overlayIsOpen.value;
  }

  const mobileSearchOpen = ref(false);

  const mobileExtendedSearchOpen = ref(false);

  const saveSearchModalIsOpen = ref(false);
  function toggleSaveSearchModal() {
    saveSearchModalIsOpen.value = !saveSearchModalIsOpen.value;
  }

  const disruptionBanner = ref<DisruptionInfo>({
    state: "inactive",
    sections: ["all"],
    messageDe: "",
    messageEn: "",
    messageEs: "",
  });
  function updateDisruptionBanner(payload: DisruptionInfo) {
    disruptionBanner.value = payload;
  }

  const deleteSearchModalId = ref<string | null>(null);
  function toggleDeleteSearchModal(savedSearchId?: string) {
    if (savedSearchId === deleteSearchModalId.value || !savedSearchId) {
      return (deleteSearchModalId.value = null);
    }
    deleteSearchModalId.value = savedSearchId;
  }

  const renameSearchModalId = ref<string | null>(null);
  function toggleRenameSearchModal(savedSearchId?: string) {
    if (savedSearchId === renameSearchModalId.value || !savedSearchId) {
      return (renameSearchModalId.value = null);
    }
    renameSearchModalId.value = savedSearchId;
  }

  const notificationSearchModalId = ref<string | null>(null);

  type SnackbarMessage = {
    message: string;

    type: "info" | "error" | "success";
    icon?: UiIconName;
    autoHide: boolean;
    actionLabel?: string;
    actionCallback?: () => void;
  };

  const snackbarMessages = ref<SnackbarMessage[]>([]);

  function addSnackbarMessage(
    message: string,
    type: "info" | "error" | "success" = "info",
    icon?: UiIconName,
    autoHide: boolean = true,
    actionLabel?: string,
    actionCallback?: () => void,
  ) {
    snackbarMessages.value.push({
      message,
      type,
      icon,
      autoHide,
      actionLabel,
      actionCallback,
    });
  }

  function resetSnackbarMessages() {
    snackbarMessages.value = [];
  }

  const morningBriefingBanner = ref<MorningBriefing>({
    active: false,
    url: "",
  });

  function updateMorgenlageBanner(payload: MorningBriefing) {
    morningBriefingBanner.value = payload;
  }

  return {
    isLoggedIn,
    mobileSearchOpen,
    feedDetailIsOpen,
    openFeedDetail,
    closeFeedDetail,
    renameSearchModalId,
    toggleRenameSearchModal,
    overlayIsOpen,
    toggleOverlayIsOpen,
    mobileExtendedSearchOpen,
    saveSearchModalIsOpen,
    toggleSaveSearchModal,
    disruptionBanner,
    updateDisruptionBanner,
    morningBriefingBanner,
    updateMorgenlageBanner,
    deleteSearchModalId,
    toggleDeleteSearchModal,
    snackbarMessages,
    addSnackbarMessage,
    resetSnackbarMessages,
    notificationSearchModalId,
  };
});
